/* eslint-disable import/no-default-export */

export { StorefrontHead } from './StorefrontHead';

export { PageHead } from './PageHead';
export { DevelopmentHead } from './DevelopmentHead';
